import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M114-336q-31 0-55-24-25-24-25-56v-56l-1-17q-1-9 2-16l129-297q11-26 37-45 25-18 54-18h446v529L496-118q-18 19-42 24-24 4-46-7t-32-35q-10-23-3-48l32-152H114Zm514-40v-409H242L115-483v67h384l-48 228 177-188Zm193-489q33 0 57 23 23 23 23 57v369q0 33-23 56-24 24-57 24H701v-80h120v-369H701v-80h120Zm-193 80v409-409Z"/>',
  f: '<path d="M109-336q-31 0-55-25-25-24-25-55v-56q0-12 3-28t8-27l119-275q10-26 36-44 26-19 55-19h390q33 0 56 23t23 57v417q0 15-6 29-5 14-16 25L517-123q-18 19-43 24t-47-7q-22-11-32-34-11-23-5-49l31-147H109Zm731-529q24 0 42 18t18 42v408q0 25-18 43-17 18-41 18h-2q-24 0-42-18t-18-42v-409q0-24 18-42t42-18h1Z"/>',
};

export default data;
